import React, { useState, useEffect } from 'react';
import LiveEcosystemOverview from '../components/dashboard/LiveEcosystemOverview';
import RevenueChart from '../components/dashboard/RevenueChart';
import OrdersChart from '../components/dashboard/OrdersChart';
import RecentOrders from '../components/dashboard/RecentOrders';
import LowStockAlert from '../components/dashboard/LowStockAlert';
import TopPerformingPanels from '../components/dashboard/TopPerformingPanels';
import CommandQuickActions from '../components/dashboard/CommandQuickActions';
import { dashboardService } from '../services/api.service';

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const fetchStats = async () => {
      try {
        const res = await dashboardService.getStats();
        if (isMounted && res && res.success) {
          setDashboardData(res.data);
        }
      } catch (err) {
        console.warn("Failed to load live dashboard stats:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchStats();
    return () => { isMounted = false; };
  }, []);

  return (
    <>
      {/* Row 1: Core E-Commerce KPI Metrics Cards */}
      <LiveEcosystemOverview kpis={dashboardData?.kpis} loading={loading} />

      {/* Row 2: Sales & Revenue Analytics Charts */}
      <div className="charts-double-grid">
        <RevenueChart data={dashboardData?.revenue_trend} loading={loading} />
        <OrdersChart data={dashboardData?.daily_orders_trend} loading={loading} />
      </div>

      {/* Row 3: E-Commerce Store Operations (Recent Orders, Low Stock Alerts) */}
      <div className="charts-double-grid">
        <RecentOrders orders={dashboardData?.recent_orders} loading={loading} />
        <LowStockAlert items={dashboardData?.low_stock_alerts} loading={loading} />
      </div>

      {/* Row 4: Top Performing Panels & Quick Store Actions */}
      <div className="charts-double-grid">
        <TopPerformingPanels panels={dashboardData?.top_performing_panels} loading={loading} />
        <CommandQuickActions />
      </div>
    </>
  );
};

export default Dashboard;
